import { inject, observer } from 'mobx-react';
import { Lambda, reaction } from 'mobx';
import * as React from 'react';

import { UIPageStore } from 'stores/ui-page-store';

export interface FocusTargetProps {
  uiPage?: UIPageStore;
  targetKey: string;
}

@inject('uiPage')
@observer
export class FocusTarget extends React.Component<FocusTargetProps, { targetKey?: string }> {
  constructor(props: Readonly<FocusTargetProps>) {
    super(props);

    this.focusRef = React.createRef();

    this.checkFocusTarget = this.checkFocusTarget.bind(this);
  }

  private focusRef: React.RefObject<any> | null = null;

  private disposer: Lambda | undefined;

  public checkFocusTarget({ targetKey, executor }: { targetKey: unknown; executor: unknown }) {
    const props = this.props;

    if (!targetKey || !executor) {
      return;
    }

    if (typeof props.targetKey === 'string' && props.targetKey.length > 0 && props.targetKey === targetKey) {
      if (typeof executor === 'function') {
        const focusRef = this.focusRef && this.focusRef.current;

        executor(this.props.targetKey, () => {
          if (focusRef && typeof focusRef.scrollIntoView === 'function') {
            focusRef.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
            });
          }
        });
      }
    }
  }

  public componentDidMount() {
    this.disposer = reaction(() => {
      const uiPageStore = this.props.uiPage;
      const focusItem = uiPageStore && uiPageStore.focusItem;
      const targetKey = focusItem && focusItem.targetKey;
      const executor = focusItem && focusItem.executor;

      return {
        targetKey,
        executor,
      };
    }, this.checkFocusTarget);
  }

  public componentWillUnmount() {
    this.disposer && this.disposer();
  }

  public render() {
    return (
      <>
        <span ref={this.focusRef} />
        {this.props.children}
      </>
    );
  }
}
